/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';
import { regionToCountriesMap } from 'js/constants.js';

const componentName = 'blind-submit-form';
class BlindSubmitForm extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        // Form
        form: this.element.querySelector('form'),
        bpidInput: this.element.querySelector('input[name="$Question2Text"]'),
        emailInput: this.element.querySelector('input[name="$PrepopEmailAddress"]'),
        urlInput: this.element.querySelector('input[name="$FormURL"]'),
        formNameInput: this.element.querySelector('input[name="elqFormName"]'),
        regionInput: this.element.querySelector('input[name="$Region"]'),
    };

    state = {
        isSignedIn: false,
        userInfo: {
            origin: 'Marketing',
            isTest: false,
            shipToBpid: '',
            softwarePortalLoginEmail: '',
            catalogNumber: '',
            intendedUse: '',
            contactFirstName: '',
            contactLastName: '',
            contactEmail: '',
            contactPhone: '',
            contactCompany: '',
            contactAddress1: '',
            contactAddress2: '',
            contactCity: '',
            contactProvince: 'N/A',
            contactPostCode: '',
            contactCountryCode: '',
            contactCountryName: '',
            contactFax: '',
        },
    };

    constants = {
        eloquaEndpoint: '',
        theme: 'ra',
        autoSubmit: this.elements.form.dataset.autoSubmit === 'true',
        minViewTime: this.elements.form.dataset.minViewTime || 5,
        formFieldToUserInfoMap: {
            '$FirstName': 'contactFirstName',
            '$LastName': 'contactLastName',
            '$EmailAddress': 'contactEmail',
            '$Telephone': 'contactPhone',
            '$Company': 'contactCompany',
            '$AddressLine1': 'contactAddress1',
            '$AddressLine2': 'contactAddress2',
            '$City': 'contactCity',
            '$StateorProvince': 'contactProvince',
            '$Postcode': 'contactPostCode',
            '$Country': 'contactCountryCode',
            '$Fax': 'contactFax',
            '$Comments': 'intendedUse',
        },
    };

    checkSignInStatus = () => {
        let loggedInData = {};
        if (typeof getPiraObj === 'function') {
            const piraObj = getPiraObj();
            loggedInData = {
                firstName: piraObj.fn,
                lastName: piraObj.ln,
                email: piraObj.em,
                phone: piraObj.myPhone,
                company: piraObj.companyName,
                countryCode: piraObj.country,
                bpid: piraObj.bpid,
            };
        }
        if (window['userData']) {
            this.state.isSignedIn = true;
            loggedInData.firstName = loggedInData.firstName || window['userData'].firstName;
            loggedInData.lastName = loggedInData.lastName || window['userData'].lastName;
            loggedInData.email = loggedInData.email || window['userData'].email;
            loggedInData.phone = loggedInData.phone || window['userData'].phone;
            loggedInData.company = loggedInData.company || window['userData'].company;
            loggedInData.address = loggedInData.address || window['userData'].address;
            loggedInData.city = loggedInData.city || window['userData'].city;
            loggedInData.region = loggedInData.region || window['userData'].region;
            loggedInData.zip = loggedInData.zip || window['userData'].zip;
            loggedInData.countryCode = loggedInData.countryCode || window['userData'].countryCode;
            loggedInData.country = loggedInData.country || window['userData'].country;
            loggedInData.bpid = loggedInData.bpid || window['userData'].bpid;
        } else if (localStorage.getItem('loggedInData')) {
            try {
                const loginObject = JSON.parse(localStorage.getItem('loggedInData'));
                loggedInData.firstName = loggedInData.firstName || loginObject.firstName;
                loggedInData.lastName = loggedInData.lastName || loginObject.lastName;
                loggedInData.email = loggedInData.email || loginObject.email;
                loggedInData.phone = loggedInData.phone || loginObject.phone;
                loggedInData.company = loggedInData.company || loginObject.company;
                loggedInData.address = loggedInData.address || loginObject.address;
                loggedInData.city = loggedInData.city || loginObject.city;
                loggedInData.region = loggedInData.region || loginObject.region;
                loggedInData.zip = loggedInData.zip || loginObject.zip;
                loggedInData.countryCode = loggedInData.countryCode || loginObject.countryCode;
                loggedInData.country = loggedInData.country || loginObject.country;
                loggedInData.bpid = loggedInData.bpid || loginObject.bpid;
                this.state.isSignedIn = true;
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.state.userInfo.contactFirstName = loggedInData.firstName || '';
            this.state.userInfo.contactLastName = loggedInData.lastName || '';
            this.state.userInfo.contactEmail = loggedInData.email || '';
            this.state.userInfo.softwarePortalLoginEmail = loggedInData.email || '';
            this.state.userInfo.contactPhone = loggedInData.phone || '';
            this.state.userInfo.contactCompany = loggedInData.company || '';
            this.state.userInfo.contactAddress1 = loggedInData.address || '';
            this.state.userInfo.contactCity = loggedInData.city || '';
            this.state.userInfo.contactProvince = loggedInData.region || '';
            this.state.userInfo.contactPostCode = loggedInData.zip || '';
            this.state.userInfo.contactCountryCode = loggedInData.countryCode || '';
            this.state.userInfo.contactCountryName = loggedInData.country || '';
            this.state.userInfo.shipToFirstName = loggedInData.firstName || '';
            this.state.userInfo.shipToBpid = loggedInData.bpid || '';
        }
    };

    presetFormFields = () => {
        const formFields = this.elements.form.querySelectorAll('input');
        formFields.forEach((field) => {
            const fieldName = field.getAttribute('name');
            if (this.constants.formFieldToUserInfoMap[fieldName]) {
                const userInfoKey = this.constants.formFieldToUserInfoMap[fieldName];
                if (this.state.userInfo[userInfoKey]) {
                    field.value = this.state.userInfo[userInfoKey];
                }
            }
        });
        Object.keys(regionToCountriesMap).forEach((region) => {
            if (regionToCountriesMap[region].includes(this.state.userInfo.contactCountryName)) {
                this.elements.regionInput.value = region;
            }
        });
    };
    
    postToEloqua = async (formData) => {
        if (!this.constants.eloquaEndpoint) {
            console.warn('Eloqua endpoint is not set.');
            return;
        }
        try {
            const eloquaRequestUrl = new URL(this.constants.eloquaEndpoint);
            const eloquaPostBody = {};
            for (const [key, value] of formData.entries()) {
                if (key === '$PrepopEmailAddress') {
                    eloquaPostBody[key] = value;
                    eloquaPostBody['$EmailAddress'] = value;
                } else {
                    eloquaPostBody[key] = value;
                }
            }

            // Check for UTM parameters in query string
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('utm_campaign')) {
                eloquaPostBody['utm_campaign'] = urlParams.get('utm_campaign');
            }
            if (urlParams.get('utm_creative')) {
                eloquaPostBody['utm_creative'] = urlParams.get('utm_creative');
            }
            if (urlParams.get('utm_medium')) {
                eloquaPostBody['utm_medium'] = urlParams.get('utm_medium');
            }
            if (urlParams.get('utm_placement')) {
                eloquaPostBody['utm_placement'] = urlParams.get('utm_placement');
            }
            if (urlParams.get('utm_source')) {
                eloquaPostBody['utm_source'] = urlParams.get('utm_source');
            }
            if (urlParams.get('utm_content')) {
                eloquaPostBody['utm_content'] = urlParams.get('utm_content');
            }
            if (urlParams.get('utm_term')) {
                eloquaPostBody['utm_term'] = urlParams.get('utm_term');
            }

            const response = await fetch(eloquaRequestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                mode: 'no-cors',
                body: new URLSearchParams(eloquaPostBody),
            });
            const data = await response.text();
            if (!response.ok) {
                console.warn('Eloqua error:', data);
            }
            return data;
        } catch (error) {
            console.warn('Error posting to Eloqua:', error);
            return;
        }
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', (event) => {
            event.preventDefault();
            if (!this.state.userInfo.contactEmail) {
                return;
            }

            const formData = new FormData(this.elements.form);
            this.postToEloqua(formData);
        });
    };

    initDom = () => {
        // Check sign-in status
        this.checkSignInStatus();
        this.addEventListeners();

        // Set data values
        this.state.userInfo.origin = this.elements.container.getAttribute('data-origin') || this.state.userInfo.origin;
        this.state.userInfo.catalogNumber = this.elements.container.getAttribute('data-catalog-number') || this.state.userInfo.catalogNumber;
        this.constants.theme = this.elements.container.getAttribute('data-theme') || this.constants.theme;
        this.constants.eloquaEndpoint = this.elements.container.getAttribute('data-eloqua-endpoint') || this.constants.eloquaEndpoint;
        this.elements.urlInput.value = window.location.origin + window.location.pathname;
        this.elements.bpidInput.value = this.state.userInfo.shipToBpid || this.elements.bpidInput.value;
        this.elements.emailInput.value = this.state.userInfo.softwarePortalLoginEmail || this.elements.emailInput.value;

        this.presetFormFields();

        let autoSubmitTimeout;
        if (this.constants.autoSubmit && !window.sessionStorage.getItem(`${this.elements.form.id}-submitted`)) {
            autoSubmitTimeout = setTimeout(() => {
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                if (this.elements.form) {
                    this.elements.form.dispatchEvent(submitEvent);
                    window.sessionStorage.setItem(`${this.elements.form.id}-submitted`, 'true');
                }
            }, this.constants.minViewTime * 1000);
            
            // Clear timeout on page unload
            window.addEventListener('beforeunload', () => {
                if (autoSubmitTimeout) {
                    clearTimeout(autoSubmitTimeout);
                }
            });
        }
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.initDom();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.initDom();
            });
        }
    };
}

registerComponent(`.${componentName}`, BlindSubmitForm);
